import majors from './majors.json'

export const MAJORS: string[] = majors
